import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useMemo } from 'react';
import { injectIntl } from 'react-intl-next';
import { useDefaultSuppliers } from '../..';
import { messages } from '../../../messages';
import { messages as opsgenieMessages } from './messages';
import { SearchDialogProduct } from '../../product-router';
import { OpsgenieScope } from './types';
import { useOpsgenieURLGenerators } from './url-generators';
const OPSGENIE_PRODUCT_ID = 'opsgenie';

// visible for testing
export const mapAggregatorResponseToSearchItem = alert => {
  return {
    title: alert.message,
    id: alert.id,
    meta: alert.status.charAt(0).toUpperCase() + alert.status.slice(1),
    url: alert.link,
    iconUrl: alert.iconURI,
    containerId: '' // no conatiner
  };
};
export const OpsgenieTabWithIntl = ({
  intl,
  cloudId,
  generateAdvancedSearchUrl: overriddenGenerateAdvancedSearchUrl,
  hostUrl,
  postQueryItemSupplier,
  preQueryItemSupplier,
  ...rest
}) => {
  const urlGeneratorArguments = useMemo(() => ({
    cloudId,
    hostUrl
  }), [cloudId, hostUrl]);
  const {
    viewAllLinkGenerator,
    urlGeneratorForNoResultsScreen
  } = useOpsgenieURLGenerators(urlGeneratorArguments);
  const sections = [{
    id: OpsgenieScope.OpsgenieAlert,
    title: intl.formatMessage(opsgenieMessages.opsgenie_alerts_heading),
    scope: OpsgenieScope.OpsgenieAlert,
    showResultCount: true,
    viewAllLinkGenerator,
    resultMapper: ({
      results
    }) => results.map(value => mapAggregatorResponseToSearchItem(value))
  }];
  const itemSuppliers = useDefaultSuppliers(OPSGENIE_PRODUCT_ID, sections, {
    preQueryItemSupplier,
    postQueryItemSupplier
  });
  const preQuerySectionTitleGenerator = useCallback(section => section.id === OpsgenieScope.OpsgenieAlert ? intl.formatMessage(opsgenieMessages.opsgenie_recent_alerts) : '', [intl]);
  return /*#__PURE__*/React.createElement(SearchDialogProduct, _extends({
    expandedStateInputPlaceholder: intl.formatMessage(opsgenieMessages.opsgenie_expanded_input_placeholder),
    generateAdvancedSearchUrl: overriddenGenerateAdvancedSearchUrl || viewAllLinkGenerator,
    id: OPSGENIE_PRODUCT_ID,
    preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
    searchFooterLabel: intl.formatMessage(opsgenieMessages.opsgenie_advanced_search),
    sections: sections,
    title: intl.formatMessage(messages.opsgenie_tab_label),
    urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen
  }, rest, itemSuppliers));
};

/**
 * The canonical implementation of a tab to show Opsgenie search results inside of the search dialog
 *
 * Can be imported across multiple Atlassian products and will show Opsgenie results there
 */
export const OpsgenieTab = injectIntl(OpsgenieTabWithIntl);